import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import FullPageBackground from '../layout/FullPageBackground';
import LoginBox from '../layout/LoginBox';
import Logo from '../icons/Logo';
import Button from '../layout/Button';
import LoginForm from '../forms/Login';

const Login = ({ access_token }) => {
  if(access_token) return <Redirect to="/organisations" />

  return (
    <FullPageBackground>
      <LoginBox>
        <LoginForm />
      </LoginBox>
    </FullPageBackground>
  );
}

export default connect(({ auth: { access_token: access_token } }) => ({
  access_token
}))(Login);



// WEBPACK FOOTER //
// ./src/components/pages/Login.js